module.exports = __webpack_public_path__ + "static/media/12_4.352ad656.png";